import {useQuery} from 'react-query';
import {getMissions, Mission} from '../pages/mission/MissionService';
import {useAuth} from '../features/auth/hooks/useAuth';
import {Role} from "../features/auth/types/auth.types";
import React from "react";

export function useHistoriqueBD() {
  const { userInfo, getFullName } = useAuth();
  const groups = userInfo?.roles || [];
  const isAdmin = groups.includes(Role.ADMIN);
  const isBD = groups.includes(Role.BD);

  const {
    data: missionsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<Mission[], Error>('missions', getMissions);

  const normalizeName = (name: string) => {
    return name
        .toLowerCase()
        .trim()
        .normalize("NFD") // Normalise les caractères accentués
        .replace(/\s+/g, ' ') // Remplace les espaces multiples par un seul
        .replace(/[\u0300-\u036f]/g, ""); // Supprime les accents
  };

  const missions = React.useMemo(() => {
    if (!missionsData) return [];

    if (isAdmin) {
      return missionsData;
    }

    if (isBD && userInfo?.sub) {
      const normalizedFullName = normalizeName(getFullName());

      return missionsData
          .filter(m => {
            const normalizedManager = normalizeName(m.manager || '');
            return normalizedManager === normalizedFullName;
          })
          .map(mission => ({
            ...mission,
            commercialId: userInfo.sub
          }));
    }

    return [];
  }, [missionsData, isAdmin, isBD, userInfo, getFullName]);

  return {
    missions,
    isLoading,
    isError,
    error,
    refetch,
  };
}